'use client';

import type React from 'react';
import { useUser } from '@/forApp/states/userState/userState';
import IconButton from '@/shared/Buttons/IconButton/IconButton';
import { Icons } from '@/shared/Icons/Icons';

type LikeProps = {
  className?: string;
  entity_id: number;
};

const Like: React.FC<LikeProps> = ({ className, entity_id }) => {
  const { favorites, deleteFavorite, addFavorite, user } = useUser();
  const active = favorites.includes(entity_id);

  const onClickFavorites = async () => {
    if (active) {
      deleteFavorite(entity_id);
    } else {
      addFavorite(entity_id);
    }
  };

  if (!user) return null;

  return (
    <IconButton
      ariaLabel="в избранное"
      icon={active ? <Icons.ActiveHeart /> : <Icons.Heart />}
      color="like"
      onClick={onClickFavorites}
      className={className}
    />
  );
};

export default Like;
